module.exports = __webpack_public_path__ + "static/media/coldAl.baeda391.png";